/*
 * Little Label - product card quick add (size pills + Add to cart)
 * Markup: snippets/ll-quick-add.liquid (rendered by snippets/product-card.liquid).
 *
 * Cart integration: uses the theme's own CartApi
 *   window.themeCore.CartApi.makeRequest(actions.ADD_TO_CART, {id, quantity})
 * which, on success, emits the theme EventBus "cart:updated" event. The theme's
 * cart module listens for that, refreshes the cart drawer + header count sections
 * and opens the drawer (show_cart_notification is off). We never dispatch DOM
 * CustomEvents for the cart - the theme ignores those.
 * On failure CartApi rejects with Shopify's JSON error ({status, message,
 * description}); we show the description under the button and never "Added".
 *
 * When the floating bundle tray (sections/ll-bundle-tray.liquid) is on the page, the tray is the feedback:
 * requests carry {noOpen: true}, which the theme's cart module honours, so the drawer stays closed.
 *
 * Printed once per card, so the whole thing is guarded to initialise only once;
 * document-level delegation also covers cards injected later via AJAX
 * (filters, pagination, recommendations).
 */
(function () {
	if (window.__llQuickAddInit) return;
	window.__llQuickAddInit = true;

	var ADDING = 'Adding…';
	var ADDED = 'Added ✓';
	var GENERIC_ERROR = 'Sorry, we couldn’t add that. Please try again.';
	var RESET_MS = 1500;

	function rootOf(el) {
		return el.closest('[data-llqa]');
	}

	function setLabel(btn, text) {
		var label = btn.querySelector('[data-llqa-label]');
		(label || btn).textContent = text;
	}

	function showMsg(root, text) {
		var msg = root.querySelector('[data-llqa-msg]');
		if (!msg) return;
		msg.textContent = text || '';
		msg.hidden = !text;
	}

	function selectSize(sizeBtn) {
		var root = rootOf(sizeBtn);
		if (!root || sizeBtn.disabled) return;
		var addBtn = root.querySelector('[data-llqa-add]');
		root.querySelectorAll('[data-llqa-size]').forEach(function (b) {
			b.classList.remove('is-selected');
			b.setAttribute('aria-pressed', 'false');
		});
		sizeBtn.classList.add('is-selected');
		sizeBtn.setAttribute('aria-pressed', 'true');
		root.classList.remove('llqa--nudge');
		showMsg(root, '');
		if (!addBtn) return;
		addBtn.dataset.variantId = sizeBtn.dataset.variantId;
		addBtn.dataset.qty = sizeBtn.dataset.qty || '1';
		addBtn.removeAttribute('aria-disabled');
		if (!addBtn.classList.contains('is-busy')) {
			addBtn.classList.remove('is-added');
			setLabel(addBtn, addBtn.dataset.readyLabel || 'Add to cart');
		}
	}

	function nudge(root) {
		var word = root.dataset.optionWord || 'size';
		showMsg(root, 'Please choose a ' + word + ' first');
		root.classList.remove('llqa--nudge');
		// restart the animation
		void root.offsetWidth;
		root.classList.add('llqa--nudge');
		var first = root.querySelector('[data-llqa-size]:not([disabled])');
		if (first) first.focus({ preventScroll: true });
	}

	function errorText(err) {
		if (!err) return GENERIC_ERROR;
		if (typeof err === 'string') return err;
		return err.description || err.message || GENERIC_ERROR;
	}

	function addViaFetch(params) {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		return fetch(root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: [params] })
		}).then(function (res) {
			return res.json().then(function (data) {
				if (!res.ok) throw data;
				return data;
			});
		});
	}

	// /cart/add.js only returns the added line, so the theme's "cart:updated" from
	// ADD_TO_CART carries no item_count (header badge stays stale) and the drawer
	// re-render it triggers can race Shopify's cart and come back one step behind.
	// Same as the theme's own product-card-with-form: follow up with GET_CART,
	// which emits "cart:updated" with the full cart -> header count + drawer
	// refresh + open. Then confirm the drawer shows the right quantity and ask the
	// theme to re-render it ("cart:refresh") if it is still behind.
	function drawerQuantity() {
		var drawer = document.getElementById('CartDrawer');
		if (!drawer) return null;
		var total = 0;
		drawer.querySelectorAll('[data-quantity-input]').forEach(function (input) {
			total += Number(input.value) || 0;
		});
		return total;
	}

	function ensureDrawerFresh(expected, triesLeft) {
		setTimeout(function () {
			var core = window.themeCore;
			var shown = drawerQuantity();
			if (!core || !core.EventBus || shown === null || shown === expected) return;
			core.EventBus.emit('cart:refresh');
			if (triesLeft > 1) ensureDrawerFresh(expected, triesLeft - 1);
		}, 900);
	}

	function trayOnPage() {
		return !!document.querySelector('[data-ll-tray-floating]');
	}

	function syncCart() {
		var core = window.themeCore;
		var api = core && core.CartApi;
		if (!api || !api.makeRequest || !api.actions) return;
		var req = trayOnPage()
			? api.makeRequest(api.actions.GET_CART, { noOpen: true })
			: api.makeRequest(api.actions.GET_CART);
		Promise.resolve(req)
			.then(function (cart) {
				if (cart && typeof cart.item_count === 'number') ensureDrawerFresh(cart.item_count, 3);
			})
			.catch(function () {});
	}

	function add(root, addBtn) {
		var variantId = Number(addBtn.dataset.variantId);
		if (!variantId) {
			nudge(root);
			return;
		}

		var params = { id: variantId, quantity: Number(addBtn.dataset.qty) || 1 };
		if (root.hasAttribute('data-llqa-preorder')) {
			params.properties = { '_Pre-order': 'true' };
		}
		// Theme cart module: a request whose params include noOpen does not open the drawer.
		if (trayOnPage()) params.noOpen = true;

		var readyLabel = addBtn.dataset.readyLabel || 'Add to cart';
		addBtn.classList.add('is-busy');
		addBtn.classList.remove('is-added');
		addBtn.setAttribute('aria-busy', 'true');
		setLabel(addBtn, ADDING);
		showMsg(root, '');

		var core = window.themeCore;
		var api = core && core.CartApi;
		var request;
		try {
			request = api && api.makeRequest && api.actions
				? api.makeRequest(api.actions.ADD_TO_CART, params)
				: addViaFetch(params).then(function (data) {
					// Theme cart API unavailable: fall back to the cart page so the shopper
					// still sees their bag (never leave it silently out of sync).
					window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
					return data;
				});
		} catch (e) {
			request = Promise.reject(e);
		}

		Promise.resolve(request)
			.then(function () {
				addBtn.classList.remove('is-busy');
				addBtn.removeAttribute('aria-busy');
				addBtn.classList.add('is-added');
				setLabel(addBtn, ADDED);
				setTimeout(function () {
					if (!addBtn.classList.contains('is-added')) return;
					addBtn.classList.remove('is-added');
					setLabel(addBtn, readyLabel);
				}, RESET_MS);
				syncCart();
			})
			.catch(function (err) {
				addBtn.classList.remove('is-busy', 'is-added');
				addBtn.removeAttribute('aria-busy');
				setLabel(addBtn, readyLabel);
				showMsg(root, errorText(err));
				if (window.console) console.warn('[ll-quick-add] add to cart failed', err);
			});
	}

	document.addEventListener('click', function (event) {
		var sizeBtn = event.target.closest('[data-llqa-size]');
		if (sizeBtn && rootOf(sizeBtn)) {
			event.preventDefault();
			selectSize(sizeBtn);
			return;
		}

		var addBtn = event.target.closest('[data-llqa-add]');
		if (!addBtn) return;
		var root = rootOf(addBtn);
		if (!root || addBtn.disabled) return;
		event.preventDefault();
		if (addBtn.classList.contains('is-busy')) return;
		add(root, addBtn);
	});
})();
